import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { connectSocket, disconnectSocket, socket } from "../../lib/socket";
import { useAuth } from "../auth/AuthProvider";

type SocketContextValue = {
  socket: typeof socket;
  connect: () => void;
  disconnect: () => void;
};

const SocketContext = createContext<SocketContextValue | undefined>(undefined);

export function SocketProvider({ children }: PropsWithChildren) {
  const { token } = useAuth();

  useEffect(() => {
    if (token) connectSocket();
    return () => disconnectSocket();
  }, [token]);

  return <SocketContext.Provider value={{ socket, connect: connectSocket, disconnect: disconnectSocket }}>{children}</SocketContext.Provider>;
}

export function useSocket() {
  const ctx = useContext(SocketContext);
  if (!ctx) throw new Error("useSocket must be used within SocketProvider");
  return ctx;
}
